import * as React from 'react';
import Typography from "@mui/material/Typography";
import {Container} from "@mui/material";
import SideBar from "../../componets/sideBar/sideBar";
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Button from '@mui/material/Button';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useFormik } from 'formik';
import * as Yup from "yup";
import {addVehicle, finishEditLoading, IVehicle, updateVehicle} from "../../store/vehicles";
import {unwrapResult} from "@reduxjs/toolkit";
import {AxiosError} from "axios";
import {openNotifier} from "../../store/notifier";
import {useSelector} from "react-redux";
import {generateReport, ReportSelector, startEditLoading} from "../../store/report";
import {useAppDispatch} from "../../store/store";


const validationSchema = Yup.object().shape({
    dateStart: Yup
        .string()
        .required("Start date is required"),
    dateEnd: Yup
        .string()
        .required("End date is required")
        .test('start_date_cannot_be_greater_than_end_date', 'fecha fin no puede ser menor a fecha inicio', function (dateStart,dateEnd) {
         const dateEndBeforeOrAfter=   !dayjs(dateEnd?.parent?.dateEnd).isBefore(dayjs(dateEnd?.parent?.dateStart));

           return dateEndBeforeOrAfter;
            // return dayjs(dateEnd?.parent?.dateEnd).isAfter(dayjs(dateEnd?.parent?.dateStart)) || dayjs(dateEnd?.parent?.dateEnd).isSame(dayjs(dateStart));
        })
    });

function GenerarReporte() {
    const dispatch = useAppDispatch();
    const {      report_generate: {
        isGenerate,}} = useSelector(ReportSelector);
    const {
        setFieldValue,
        errors,
        touched,
        submitForm,
        values,
        setValues,
        dirty
    } = useFormik<{dateStart:any,dateEnd:any}>({
        initialValues: {
            dateStart:dayjs(),
            dateEnd:dayjs()
        },
        validationSchema:validationSchema,
        onSubmit: (values, {resetForm}) => {
            dispatch(generateReport({dateStart:dayjs(values.dateStart).format("YYYY-MM-DD"),dateEnd:dayjs(values.dateEnd).format("YYYY-MM-DD")})).then(unwrapResult).then((result: any) => {
                resetForm()
            }).catch((result: AxiosError) => {
                // @ts-ignore
                dispatch(openNotifier({variant: "error", open: true, message: result?.message}))
            })

        },
    })
    // console.log((Object.keys(errors).length === 0 && dirty))


    return (
        <>
            <Container maxWidth="xl" className="contLayout mt-30">
                <Typography variant="h1" className="titleBody txt-dark" gutterBottom>Exportar Reporte</Typography>
                <Typography variant="h2" className="subtitleBody txt-green" gutterBottom>Filtrar por:</Typography>
                <div className="pageReporte mt-30">
                    <SideBar></SideBar>
                    <div style={{marginBottom:45}}>
                        <Typography className="subtitleBody " style={{marginBottom:15}}>Seleccione un rango de fecha</Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker', 'DatePicker']}>
                                <div className="contExportData">
                                    <DemoItem label="Fecha Inicio">
                                        <DatePicker
                                            format={'DD-MM-YYYY'}
                                            value={values.dateStart}
                                            onChange={(value, context)=>{
                                                setFieldValue(`dateStart`, value);

                                            }}
                                        />
                                    </DemoItem>
                                    <DemoItem label="Fecha Fin">
                                        <DatePicker
                                            format={'DD-MM-YYYY'}
                                            value={values.dateEnd}
                                            onChange={(value, context)=>{
                                                setFieldValue(`dateEnd`, value);
                                            }}
                                        />
                                    </DemoItem>

                                        <Button variant="contained" className="btn-descargar"
                                                              onClick={submitForm}
                                                              disabled={Object.keys(errors).length>0}
                                        ><FileDownloadIcon/> Descargar</Button>

                                    {/*<Button variant="contained" className="bg-green"*/}
                                    {/*disabled={Object.keys(errors).length>0}*/}
                                    {/*onClick={submitForm}*/}
                                    {/*>Generar</Button>*/}

                                </div>
                            </DemoContainer>
                        </LocalizationProvider>
                    </div>
                </div>
            </Container>
        </>
    );
}

export default GenerarReporte;
